import { createClient } from '@supabase/supabase-js';

export const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY
);

// Services API functions
export const getServices = async (language = 'fr') => {
  try {
    const { data, error } = await supabase
      .from('services')
      .select('key, title_fr, title_en, short_desc_fr, short_desc_en, icon, position')
      .eq('is_active', true)
      .order('position', { ascending: true });

    if (error) {
      console.error('Error fetching services:', error);
      throw error;
    }

    // Transform data to match current format
    return data.map(service => ({
      id: service.key,
      title: language === 'fr' ? service.title_fr : service.title_en,
      description: language === 'fr' ? service.short_desc_fr : service.short_desc_en,
      icon: service.icon,
      position: service.position
    }));
  } catch (error) {
    console.error('Error fetching services from Supabase:', error);
    throw error; // Let the component handle fallback
  }
};

// Contact form submission
export const submitContact = async (contactData) => {
  // Normalize language code
  const normalizeLanguage = (lang) => {
    if (!lang) return 'fr';
    const normalized = lang.toLowerCase().split('-')[0];
    return ['fr', 'en'].includes(normalized) ? normalized : 'fr';
  };

  const contactPayload = {
    name: contactData.name,
    email: contactData.email,
    company: contactData.company || null,
    phone: contactData.phone || null,
    service: contactData.service || null,
    message: contactData.message,
    language: normalizeLanguage(contactData.language),
    status: 'new',
    source: 'website'
  };

  try {
    const { data, error } = await supabase
      .from('contacts')
      .insert([contactPayload])
      .select('id')
      .single();

    if (error) {
      console.error('Error submitting contact:', error);
      throw error;
    }

    console.log('Contact successfully submitted to Supabase:', data);
    return data;
  } catch (error) {
    console.error('Contact submission failed:', error);
    // Fallback: store in localStorage for later processing
    const contactWithId = {
      ...contactPayload,
      id: Date.now().toString(),
      created_at: new Date().toISOString()
    };
    
    const existingContacts = JSON.parse(localStorage.getItem('winstep_contacts') || '[]');
    existingContacts.push(contactWithId);
    localStorage.setItem('winstep_contacts', JSON.stringify(existingContacts));
    
    console.log('Contact stored in localStorage as fallback:', contactWithId);
    return { id: contactWithId.id };
  }
};